import { render, staticRenderFns } from "./PresentOnTabletModal.vue?vue&type=template&id=48ffee30&scoped=true"
import script from "./PresentOnTabletModal.vue?vue&type=script&lang=js"
export * from "./PresentOnTabletModal.vue?vue&type=script&lang=js"
import style0 from "./PresentOnTabletModal.vue?vue&type=style&index=0&id=48ffee30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ffee30",
  null
  
)

export default component.exports